import { render } from "./MaterialDeleteFormModal.vue?vue&type=template&id=02c3c799&lang=pug"
import script from "./MaterialDeleteFormModal.vue?vue&type=script&lang=ts"
export * from "./MaterialDeleteFormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script